import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        ok: '&',
        cancel: '&',
        user: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ vm.user.displayName }}</h2>
        </div>
        <div class="modal-body">
            <div class="heading01 type01">
                <h3>{{ 'planning.List of courses' | translate }}</h3>
            </div>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <div class="form" ng-if="vm.list.items.length">
                <table class="data01"
                    ng-if="!vm.list.loading && vm.list.items.length"
                    ng-init="vm.initBulk()"
                    datatable dt-options="vm.DATATABLES">
                    <thead>
                    <tr>
                        <th class="w1p nosort">
                            <input
                                ng-if="vm.PrivilegeService.canManagePlanning()"
                                ng-model="vm.checked"
                                ng-click="vm.toggleAll()"
                                type="checkbox"
                            >
                        </th>
                        <th>{{ 'planning.Course' | translate }}</th>
                        <th>{{ 'planning.Personal deadline' | translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <form-row error="vm.errors.courseIds">
                            <form-row-error></form-row-error>
                        </form-row>
                        <tr ng-repeat="item in vm.list.items">
                            <td><input type="checkbox" ng-if="vm.PrivilegeService.canManagePlanning()"
                                ng-checked="vm.hasId(item.courseId)"
                                ng-click="$event.stopPropagation();vm.toggleId(item.courseId)"
                            ></td>
                            <td>{{ item.name }}</td>
                            <td ng-bind-html="item.deadline | personalDeadline: item.previousPassedTime:item.isInfiniteDeadline"></td>
                        </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
                <div class="row">
                    <form-row error="vm.errors.deadline" ng-if="vm.PrivilegeService.canManagePlanning()">
                        <label class="label">{{ 'planning.Deadline' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <datepicker-api
                                ng-id="'deadlineDatepicker'"
                                ng-disabled="vm.form.removeDeadline"
                                ng-model="vm.form.deadline"
                            />
                        </div>
                    </form-row>
                </div>
                <br />
                <div class="row">
                    <form-row error="vm.errors.removeDeadline" ng-if="vm.PrivilegeService.canManagePlanning()">
                        <label class="label">{{ 'planning.Remove personal deadline' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ul class="checkboxes03">
                                <li>
                                    <input
                                        ng-disabled="vm.form.deadline"
                                        ng-model="vm.form.removeDeadline"
                                        ng-change="vm.clearDeadline('deadlineDatepicker')"
                                        type="checkbox"
                                    >
                                </li>
                            </ul>
                        </div>
                    </form-row>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li  class="primary" ng-if="vm.list.items.length && vm.PrivilegeService.canManagePlanning()">
                    <button class="btn main" type="button" ng-click="vm.submit()">{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})

export default class {
    constructor ($translate, $rootScope, moment, lodash, DATATABLES, MomentService,
                 ListFactory, UserResource, ModalService, PrivilegeService) {
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.lodash = lodash;
        this.moment = moment;
        this.DATATABLES = DATATABLES;
        this.UserResource = UserResource;
        this.list = ListFactory.createWithPagination(UserResource.trainingNeedUserCourses.bind(UserResource));
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.PrivilegeService = PrivilegeService;
    }

    $onInit () {
        this.list.fetch({ id: this.user.id });
        this.form = { deadline: null };
    }

    initBulk () {
        this.form.courseIds = [];
        this.checked = false;
    }

    clearDeadline (datepickerId) {
        this.$rootScope.$broadcast(`clear:datepicker:${datepickerId}`);
    }

    toggleAll () {
        this.form.courseIds = this.checked ? this.list.items.map((item) => item.courseId) : [];
    }

    hasId (id) {
        return this.lodash.includes(this.form.courseIds, id);
    }

    toggleId (id) {
        if (this.hasId(id)) {
            this.lodash.pull(this.form.courseIds, id);
            this.checked = false;
        }
        else {
            this.form.courseIds.push(id);
        }
    }

    submit () {
        // send a validation request, no saving is done with validateOnly=true
        this.UserResource.setTrainingNeed({ id: this.user.id, validateOnly: true }, this.form).$promise
            .then((form) => {
                // clear errors
                this.errors = {};
                const coursesWithExistingDeadline = [];
                this.lodash.forEach(this.list.items, (item) => {
                    if (item.deadline && this.hasId(item.courseId)) {
                        coursesWithExistingDeadline.push(item.name);
                    }
                });
                if (coursesWithExistingDeadline.length) {
                    let message = '';
                    if (form.removeDeadline) {
                        message = this.$translate.instant('planning.needs.confirm.courses.deadline.remove', {
                            courses: coursesWithExistingDeadline.join(', ')
                        });
                    }
                    else {
                        message = this.$translate.instant('planning.needs.confirm.courses.deadline', {
                            deadline: this.MomentService.formatDate(form.deadline),
                            courses: coursesWithExistingDeadline.join(', ')
                        });
                    }

                    // open confirmation modal
                    this.ModalService.confirm(message, 'medium').then(() => this.save(form));
                }
                else {
                    this.save(form);
                }
            })
            .catch((response) => this.handleErrorResponse(response));
    }

    save (form) {
        this.UserResource.setTrainingNeed({ id: this.user.id }, form).$promise
            .then(() => {
                this.ok();
            })
            .catch((response) => this.handleErrorResponse(response));
    }

    handleErrorResponse (response) {
        this.errors = {};
        this.lodash.forEach(response.data, (error) => {
            this.errors[error.field] = error.message;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/courses/deadline/index.js